import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=2e8f4b88"
import script from "./dropdown.ts?vue&type=script&lang=js&external"
export * from "./dropdown.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e8f4b88')) {
      api.createRecord('2e8f4b88', component.options)
    } else {
      api.reload('2e8f4b88', component.options)
    }
    module.hot.accept("./dropdown.vue?vue&type=template&id=2e8f4b88", function () {
      api.rerender('2e8f4b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/dropdown/dropdown.vue"
export default component.exports